/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBadgeAr = createReactComponent("outline", "badge-ar", "IconBadgeAr", [["path", { "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M7 15v-4.5a1.5 1.5 0 0 1 3 0v4.5", "key": "svg-1" }], ["path", { "d": "M7 13h3", "key": "svg-2" }], ["path", { "d": "M14 12h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6m3 0l-2 -3", "key": "svg-3" }]]);

export { IconBadgeAr as default };
//# sourceMappingURL=IconBadgeAr.mjs.map
